import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import redirectURL from "../redirectURL";

var colors = ["#FF7F50","#00C292", "#0593AA","#A98300","#944E63", "#211C6A"];
var colors1 = ["#FF7F50","#00C292", "#0593AA"];

var decipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded => encoded.match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"));
class PTLConsignmentChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      total: 0,
      inactive: 0,
      active: 0,
      delivered: 0,
      epod: 0,
      totalcount: 0,
      transitDelay: 0,
      ontimeDelivered: 0,
      epodPending: 0,
    };
  }

  componentDidMount() {
    this.getdata();
  }

  getdata = async () => {
    var params ={}
    var location_name = localStorage.getItem("location");
    location_name = (location_name && location_name !=="undefined" && location_name !==null) ? location_name.split(",").filter(Boolean) : [];
    var locationNameConversion = location_name.map(e => e.trim().toLowerCase());
    var entity1 = localStorage.getItem("entity")
  entity1 = (entity1 && entity1 !== "undefined" && entity1.trim() !== "" && entity1 !== null) 
  ? entity1.split(",").map(x => x.trim()).filter(Boolean) 
  : [];    
  var entityConversion = entity1.map(e=> e.trim().toLowerCase())    // if(decode(localStorageRole).toLowerCase() === "user"){
      if (
        locationNameConversion &&
        locationNameConversion.length > 0 &&
        !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
) {         
      params.consigner_code = locationNameConversion;
        // params.consignee_code = location_name;      
      }
      if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
        params.truck_seal_entity = entityConversion
    }
    await redirectURL.post('/getpiechartforptl', params).then((resp) => {
    var records = resp.data;
    var inactive = records.filter((e) => ((e.consignment_status === "Booked" || e.consignment_status === "" || e.consignment_status === null) && (!e.lr_no_updated && e.invoice_no && e.tracking_type)));
    var active = records.filter((e) => (e.consignment_status === "In Transit" || e.consignment_status === "Out For Delivery" || 
    (e.consignment_status === "Dispatched from Source" && (e.lr_no!=="" && e.lr_no!==undefined))));
    var delivered = records.filter((e) => ((e.lr_no !== "" && e.lr_no !== undefined) && (e.consignment_status === "Delivered" || e.consignment_status == "Arrived At Destination" || e.consignment_status == "Trip Completed")));
    var total = records.filter((e) => ((e.lr_no!=="" && e.lr_no!==undefined) &&(e.hasOwnProperty("tracking_type"))));
    var epod = records.filter((e) => e.epod_uploaded === undefined);
    var epodPending =  delivered.filter((e) =>  (
      !e.hasOwnProperty("is_submitted_pod") || e.is_submitted_pod ==0
     
    ) && (e.consignment_status == 'Delivered'))
    // overspeed = total.filter((e) => e.overspeeding_exception === 1).length
  
    var transitDelay = delivered.filter((e) => e.transit_delay >0);
    var onTimeDelivered = delivered.filter((e)=> e.ontime_status === 1)
    var data = [
    { name: 'Inactive', y: inactive.length },
    { name: 'Active', y: active.length },
    { name: 'Delivered', y: delivered.length },
    ];
    var total1 = active.length + delivered.length;

    this.setState({ 
        series: data,
        total: total1,
        inactive: inactive.length,
        active: active.length,
        delivered: delivered.length,
        epod: epod.length,
        transitDelay: transitDelay.length,
        ontimeDelivered: onTimeDelivered.length,
        epodPending: epodPending.length
    }, () => {
        this.renderChart();
        }); 
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.series !== this.state.series && this.state.series.length > 0) {
      this.renderChart();
    }
  }

  renderChart = () => {
    const totalCount = this.state.total.length;

    Highcharts.chart('container-d', {
      chart: {
        type: 'pie',
        custom: {},
        events: {
            render: function() {
                const chart = this,
                series = chart.series[0];
                // let customLabel = chart.customLabel;
                // let customTotalLabel = chart.customTotalLabel;

                // if (!customLabel) {
                // customLabel = chart.customLabel =
                //     chart.renderer.label(
                //     'Consignments'
                //     )
                //     .css({
                //         color: '#000',
                //         textAnchor: 'middle',
                //         marginBottom: "20px"
                //     })
                //     .add();
                // }

                // if (!customTotalLabel) {
                // customTotalLabel = chart.customTotalLabel =
                //     chart.renderer.label(
                //     totalCount
                //     )
                //     .css({
                //         color: '#000',
                //         textAnchor: 'middle'
                //     })
                //     .add();
                // }

                // const x = series.center[0] + chart.plotLeft,
                // y = series.center[1] + chart.plotTop - customLabel.attr('height') / 2;

                // customLabel.attr({
                // x,
                // y
                // });

                // customTotalLabel.attr({
                // x,
                // y: y + 20
                // });

                // customLabel.css({
                // fontSize: `${series.center[2] / 12}px`
                // });

                // customTotalLabel.css({
                // fontSize: `${series.center[2] / 10}px`
                // });
            }
        }
      },
      accessibility: {
        point: {
          valueSuffix: ''
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      tooltip: {
        pointFormat: '{series.name}: {point.y:.0f} <b>({point.percentage:.0f}%)</b>'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          // borderRadius: 8,
          dataLabels: [
            {
              enabled: false,
              distance: 20,
              format: '{point.name}'
            },
            {
              enabled: false,
              distance: -15,
              format: '{point.y:.0f}',
              style: {
                fontSize: '0.9em'
              }
            }
          ],
          showInLegend: true
        }
      },
      colors: colors1,
      series: [{
        name: 'Orders',
        colorByPoint: true,
        innerSize: '45%',
        data: this.state.series,
      }],
      credits: false
    });
  };


  render() {
    return (
      <div className="card row h-100">
        <div className="card-body">
          <div className="d-flex flex-row justify-content-between align-items-center w-100 pb-2 pr-5">
            <div className="ml-4 mt-2 font-weight-bold d-flex flex-row justify-content-center align-items-baseline">
              <span className="ml-2 f18">PTL Summary</span>
            </div>
          </div>

          <div className="d-flex flex-row justify-content-between align-items-center leFadeInLeft w-100 pr-1">
            <div className='col-sm-6'>
              <div id="container-d" style={{ height: '300px', width: '100%' }}></div>
            </div>
            <div className='col-sm-6'>
              <div className="d-flex flex-column justify-content-center leFadeInLeft pl-3 pr-4 mr-4 donut-content-sec">
                <ul className="chart-info">
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[3], cursor: 'pointer' }} onClick={() => window.location.href = "consignments/all_consignments"}>
                    Total
                    <span>{this.state.total}</span>
                  </li>
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[0], cursor: 'pointer' }} onClick={() => window.location.href = "consignments/inactive_consignments"}>
                    In Active
                    <span>{this.state.inactive}</span>
                  </li>
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[1], cursor: 'pointer' }} onClick={() => window.location.href = "consignments/active_consignments"}>
                    Active
                    <span>{this.state.active}</span>
                  </li>
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[2], cursor: 'pointer' }} onClick={() => window.location.href = "consignments/delivered_consignments"}>
                    Delivered
                    <span>{this.state.delivered}</span>
                  </li>
                  {/* <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[3], cursor: 'pointer' }} onClick={() => window.location.href = "dipatchplanhistory?" + 'Epod'}>
                    E POD
                    <span>{this.state.epod}</span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="d-flex flex-column justify-content-center leFadeInLeft pl-3 pr-4 mr-4 donut-content-sec">
              <div className="row">
                <div className="col card card-bx" style={{display:"flex", flexDirection:"column", justifyContent:"space-evenly", padding:"20px"}}>
                  <div className="card-body" style={{ color: colors[5], textAlign: 'center', padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
                    <h6 style={{ marginBottom: '5px', fontSize: '16px' }}>Transit Delay</h6>
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{this.state.transitDelay}</div>
                  </div>
                </div>

                <div className="col card card-bx" style={{display:"flex", flexDirection:"column", justifyContent:"space-evenly", padding:"20px"}}>
                  <div className="card-body" style={{ color: colors[5], textAlign: 'center', padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
                    <h6 style={{ marginBottom: '5px', fontSize: '16px' }}>Ontime Delivered</h6>
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{this.state.ontimeDelivered}</div>
                  </div>
                </div>

                <div className="col card card-bx" style={{display:"flex", flexDirection:"column", justifyContent:"space-evenly", padding:"20px"}}>
                  <div className="card-body" style={{ color: colors[5], textAlign: 'center', padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
                    <h6 style={{ marginBottom: '5px', fontSize: '16px' }}>EPOD Pending</h6>
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{this.state.epodPending}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PTLConsignmentChart;